import { Icon } from 'semantic-ui-react'
import {getImagePath} from '../utils/general.js';

const Footer = () => {
  
  return(
    
    <div id="footer">
      <img className='headerImage' id="setarPicture" src={getImagePath("setar.png", "header")} alt="Setar" />
      <ul id="footerIcons">
          <li><a href="https://soundcloud.com/shervn"><Icon name='soundcloud' /></a></li>
          <li><a href="https://github.com/shervn/"><Icon name='github' /></a></li>
          <li><a href="mailto:shervin.dehghani@gmail.com"><Icon name='mail' /></a></li>
      </ul>
      <h5 className='englishPost'>© shervn {new Date().getFullYear()}</h5>
      <br/>
    </div>
  )
}

export default Footer
